class CareerView extends ViewBasic {
    constructor(options) {
        super(options);
    }

    init(){
        this.addEvents();
    }

    addEvents() {
        this.$('.single-restaurant-infos .primary-cta').on('click', e => this.applyToOpeningWithBranchAndCareer(e));

        // @NOTE 4C4 - NOT NEEDED
        // this.$('.career-spontaneous .primary-cta, .career-apply .primary-cta').on('click', e => this.applyToOpeningWithCareer(e));
    }

    removeEvents() {
        this.$('.single-restaurant-infos .primary-cta').off('click', e => this.applyToOpeningWithBranchAndCareer(e));
    }

    // @NOTE 4C4 - NOT NEEDED
    // applyToOpeningWithCareer(e){/
    //     e.preventDefault();
    //     let view = this;
    //
    //     setTimeout(function(){
    //         Me.dispatch.emit('Career.prefillInfos', this, {careerId: view.options.careerId, careerTitle: view.options.careerTitle});
    //     },0);
    // }

    applyToOpeningWithBranchAndCareer(e){
        e.preventDefault();
        let view = this;

        setTimeout(function(){
            Me.dispatch.emit('Career.prefillInfos', this, {
                branchId: $(e.currentTarget).parents('.single-restaurant-infos').attr('data-id'),
                branchTitle: $(e.currentTarget).parents('.single-restaurant-infos').attr('data-title') 
            });
        },0);
    }
}

